import { combineReducers } from "redux";
import { initialReducer } from './initialReducer.js'
import { userReducer } from "./userReducer.js";
import { companyReducer } from "./companyReducer.js";


const rootReducer = combineReducers({ initialReducer, userReducer, companyReducer });
export default rootReducer;

